import { render, staticRenderFns } from "./CarrierMessage.vue?vue&type=template&id=02584f3b&scoped=true"
import script from "./CarrierMessage.vue?vue&type=script&lang=js"
export * from "./CarrierMessage.vue?vue&type=script&lang=js"
import style0 from "./CarrierMessage.vue?vue&type=style&index=0&id=02584f3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02584f3b",
  null
  
)

export default component.exports